import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type ProductDetailContext } from '../../types/types';

const Reviews = (): JSX.Element => {
    const { product, reviewPartnerConfiguration } = useFragmentContext<ProductDetailContext>();

    return (
        <div
            className="yotpo yotpo-main-widget yotpo-widget-instance"
            id="yotpo-tabs-main-widget-tab-0"
            data-yotpo-instance-id={reviewPartnerConfiguration.instanceId}
            data-yotpo-product-id={product.productId}
            data-yotpo-name={product.title}
            data-yotpo-url={product.url}
            data-yotpo-image-url={product.images[0].absoluteUrl}
            data-yotpo-price={product.price.gross.amount}
            data-yotpo-currency={product.price.gross.currencyCode}
            data-testid="review-test-id"
        />
    );
};

export { Reviews };
